<icon [name]="icon" [ngClass]="on ? 'active' : 'inactive'"></icon>
<label>{{label}}</label>
@if (!showCheckbox) {
  <toggle [on]="on" (toggle)="toggle.emit($event)" [ariaLabel]="label"></toggle>
}
@if (showCheckbox) {
  <label class="custom-checkbox" (click)="handleLabelClick($event)">
    <input type="checkbox" [ngModel]="on" (click)="handleCheckboxToggle($event)" />
    <span class="checkmark"></span>
  </label>
}